import { fbt } from 'fbtee'
import { Ban, FileText, Shield } from 'lucide-react'
import { useTransitionNavigate } from '../../lib/viewTransition'
import { SettingsLinkRow, SettingsSection } from './SettingsSection'

export function PrivacySection({ signedIn }: { signedIn: boolean }) {
  const navigate = useTransitionNavigate()
  return (
    <SettingsSection title={fbt('Privacy & safety', 'Settings section holding blocked users and the legal pages')}>
      {signedIn && (
        <SettingsLinkRow
          icon={<Ban className="size-4" />}
          label={<fbt desc="Row linking to the blocked users page in Settings">Blocked users</fbt>}
          onClick={() => navigate('/settings/blocked')}
        />
      )}
      <SettingsLinkRow
        icon={<Shield className="size-4" />}
        label={<fbt desc="Link to the privacy policy page in Settings">Privacy Policy</fbt>}
        onClick={() => navigate('/privacy')}
      />
      <SettingsLinkRow
        icon={<FileText className="size-4" />}
        label={<fbt desc="Link to the terms of service page in Settings">Terms of Service</fbt>}
        onClick={() => navigate('/terms')}
      />
    </SettingsSection>
  )
}
